import * as React from "react";
import { Avatar, mergeClasses } from "@fluentui/react-components";
// Styles
import { useDynamicIconStyles } from "./DynamicIcon.styles";
/**
 * Dynamic icon that displays an image, icon, or name initials using Fluent UI v9 Avatar.
 * Built on top of Fluent UI v9 Avatar component for consistent styling and behavior.
 */ export const DynamicIcon = (props)=>{
    const { imageUrl, icon, focused = false, name, avatarProps, className, ariaLabel } = props;
    // Extract avatar properties with defaults
    const { size = 24, shape = "square", color = "colorful", ...additionalProps } = avatarProps || {};
    const styles = useDynamicIconStyles();
    // Early return if no content to display
    if (!imageUrl && !icon && !name) {
        return null;
    }
    // Determine Avatar props based on content priority: imageUrl > icon > name
    let avatarContentProps = {};
    if (imageUrl) {
        avatarContentProps = {
            color,
            image: {
                src: imageUrl
            }
        };
    } else if (icon) {
        avatarContentProps = {
            color: "brand",
            icon
        };
    } else {
        avatarContentProps = {
            name,
            color
        };
    }
    return /*#__PURE__*/ React.createElement(Avatar, {
        size: size,
        shape: shape,
        "aria-label": ariaLabel || name || undefined,
        ...additionalProps,
        ...avatarContentProps,
        className: mergeClasses(focused && styles.focused, className)
    });
};
